import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  DateAgoPipe,
  FilterValuePipe,
  LinkifyPipe,
  SafeHtmlPipe,
  TranslateChoicesPipe,
} from '@pipes';

@NgModule({
  declarations: [DateAgoPipe, FilterValuePipe, LinkifyPipe, SafeHtmlPipe, TranslateChoicesPipe],
  imports: [CommonModule],
  exports: [DateAgoPipe, FilterValuePipe, LinkifyPipe, SafeHtmlPipe, TranslateChoicesPipe],
})
export class PipeModule {}
